import React from 'react';
import Skeleton, { SkeletonProps } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export const Shimmer = (props: SkeletonProps) => (
  <Skeleton baseColor="#ebebeb" highlightColor="#f5f5f5" {...props} />
);
